<div
  *ngIf="message.id"
  class="message-reply"
  [ngStyle]="{ '--color-reply': color, '--color-link': linkColor }"
  (click)="onClickMessage(message.id)"
>
  <p class="sender">{{ message.userName }}</p>
  <div class="content">
    <span class="text">
      <ng-container [ngSwitch]="message.contentType">
        <ng-container *ngSwitchCase="'text'">
          {{ message.content.text | htmlToText }}
        </ng-container>

        <ng-container *ngSwitchDefault>
          {{ message.contentType }}
        </ng-container>
      </ng-container>
    </span>
  </div>
</div>
